/* eslint-disable camelcase */

const getAdaChatConfig = ({ JWTToken }:{ JWTToken?: string }) => ({
    sensitiveMetaFields: {
        jwt_token: JWTToken || '',
        user_is_anonymous: false
    },
    metaFields: {
        userId: window.Playtech.fetchUserDetails().userId
    },
    handle: 'sun',
    greeting: '63db6a7dcc4e26ea2b652c6c',
    mobileOverlay: true,
    hideMask: false,
    cluster: 'eu',
    lazy: true,
    zdChatterAuthCallback: (callback: (JWTToken: string) => void) => {
        callback(JWTToken || '');
    }
});

const getJWTToken = async (): Promise<string | undefined> => {
    try {
        const response = await window.Playtech.API.server.getJWTToken();

        if (response.data?.errorMessage) {
            throw new Error(response.data.errorMessage);
        }

        return response.data.jwtToken;
    } catch (error: unknown) {
        if (typeof error === 'string') {
            throw new Error(error);
        } else {
            return Promise.reject(error);
        }
    }
};

export const stopAdaEmbed = async (): Promise<void> => {
    try {
        await window.adaEmbed.stop();
        console.log('Ada has been successfully stopped!');
    } catch (error) {
        console.log('Ada is unable to stop!', error);
    }
};

export const startAdaEmbed = async (): Promise<void> => {
    const JWTToken = await getJWTToken();

    try {
        await window.adaEmbed.start(getAdaChatConfig({ JWTToken }));
        console.log('Ada has been successfully initialized!');
    } catch (error) {
        console.log('Ada is unable to initialize!', error);
    }
};

export const toggleAdaChat = async (): Promise<void> => {
    try {
        await window.adaEmbed.toggle();
        console.log('Ada chat has been successfully toggled!');
    } catch (error) {
        console.log('Ada chat is unable to toggle!', error);
    }
};

export const triggerAdaCampaign = async (command: string): Promise<void> => {
    try {
        await window.adaEmbed.triggerCampaign(command);
        console.log(`Ada run ${command} triggerCampaign`);
    } catch (error) {
        console.log(`Ada is unable to run ${command} triggerCampaign`, error);
    }
};
